export type OperationShelfLifeAction = 'open' | 'thaw';

export interface FoodOperationShelfLife {
  shelf_life_days_opened?: number | null;
  shelf_life_hours_thawed?: number | null;
}

export interface RecipeOperationShelfLife {
  shelf_life_minutes_opened?: number | null;
  shelf_life_minutes_thawed?: number | null;
}

function positiveOrNull(value: number | null | undefined): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value > 0
    ? value
    : null;
}

export function foodOperationShelfLifeHours(
  food: FoodOperationShelfLife | null | undefined,
  action: OperationShelfLifeAction,
): number | null {
  if (!food) return null;
  if (action === 'thaw') return positiveOrNull(food.shelf_life_hours_thawed);
  const days = positiveOrNull(food.shelf_life_days_opened);
  return days == null ? null : days * 24;
}

export function recipeOperationShelfLifeHours(
  recipe: RecipeOperationShelfLife | null | undefined,
  action: OperationShelfLifeAction,
): number | null {
  if (!recipe) return null;
  const minutes = positiveOrNull(
    action === 'thaw'
      ? recipe.shelf_life_minutes_thawed
      : recipe.shelf_life_minutes_opened,
  );
  return minutes == null ? null : minutes / 60;
}
